// Mock data for PMR Travels website

export const CONTACT = {
  brand: "PMR Travels",
  tagline: "Travel with PMR Safe & Secure",
  phone: "+91 9397363140",
  altPhone: "+91 9397363140",
  email: "bookings@pmrtravels.com",
  address: "By Pass Road, Near Police Station, Tehsil - Taranagar, District - Churu, Rajasthan - 331304",
  hours: "Mon - Sun · 24 Hours Available",
  social: {
    facebook: "#",
    instagram: "#",
    twitter: "#",
    youtube: "#",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Destinations", to: "/destinations" },
  { label: "Tour Packages", to: "/packages" },
  { label: "Flights", to: "/#flights" },
  { label: "Trains", to: "/#trains" },
  { label: "Buses", to: "/#buses" },
  { label: "Cars", to: "/#cabs" },
  { label: "Hotels", to: "/#hotels" },
  { label: "Fleet", to: "/#fleet" },
  { label: "Careers", to: "/careers" },
  { label: "Wallet", to: "/wallet" },
  { label: "Contact", to: "/contact" },
];

export const HERO_SLIDES = [
  {
    id: 1,
    title: "Explore Incredible India",
    subtitle: "With Comfort, Care & Confidence",
    description:
      "From the snow-capped Himalayas to Kerala's serene backwaters — your fresh new travel partner across India, since 2025.",
    image:
      "https://images.unsplash.com/photo-1494822493217-c9840aba840c?w=1920&q=80",
    cta: "Plan My Trip",
  },
  {
    id: 2,
    title: "Luxury Fleet, Anywhere You Go",
    subtitle: "Volvo · Mercedes · Tempo Travellers",
    description:
      "Premium buses and cabs for weddings, corporate tours, pilgrimage & family vacations. Sanitised, insured and always on time.",
    image:
      "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1920&q=80",
    cta: "Book Vehicle",
  },
  {
    id: 3,
    title: "Handcrafted Holiday Packages",
    subtitle: "250+ destinations · 15,000+ happy travellers",
    description:
      "Manali, Goa, Kerala, Kashmir, Ooty & more. Tailor-made itineraries by real local experts.",
    image:
      "https://images.unsplash.com/photo-1539635278303-d4002c07eae3?w=1920&q=80",
    cta: "View Packages",
  },
];

export const SERVICES = [
  {
    id: "bus",
    icon: "Bus",
    title: "Bus & Coach Hire",
    desc: "Luxury Volvo, AC sleeper, mini-bus & Tempo Traveller for any group size.",
    image:
      "https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?w=800&q=80",
  },
  {
    id: "cab",
    icon: "Car",
    title: "Cab & Taxi Rental",
    desc: "Sedans, SUVs and premium cars — hourly, daily or one-way outstation.",
    image:
      "https://images.unsplash.com/photo-1630717285906-29364ffacea0?w=800&q=80",
  },
  {
    id: "flight",
    icon: "Plane",
    title: "Flight Booking",
    desc: "Best fares on domestic and international flights — 500+ airlines.",
    image:
      "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80",
  },
  {
    id: "hotel",
    icon: "Hotel",
    title: "Hotel Reservations",
    desc: "Curated stays from budget to 5-star luxury across India & abroad.",
    image:
      "https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800&q=80",
  },
  {
    id: "train",
    icon: "TrainFront",
    title: "Train Booking",
    desc: "IRCTC-authorised e-ticketing, tatkal, and confirmed berth guidance.",
    image:
      "https://images.unsplash.com/photo-1474487548417-781cb71495f3?w=800&q=80",
  },
];

export const TRAIN_CLASSES = [
  { code: "1A", label: "AC First Class", desc: "Private cabins, premium comfort" },
  { code: "2A", label: "AC 2-Tier", desc: "Curtained berths, blankets & meals" },
  { code: "3A", label: "AC 3-Tier", desc: "Popular, well-priced AC option" },
  { code: "SL", label: "Sleeper", desc: "Budget-friendly overnight travel" },
  { code: "CC", label: "AC Chair Car", desc: "Day-time inter-city journeys" },
  { code: "EC", label: "Exec. Chair Car", desc: "Vande Bharat, Shatabdi premium" },
];

export const POPULAR_TRAINS = [
  { no: "12658", name: "Chennai Mail", from: "Bengaluru", to: "Chennai", dep: "22:40", arr: "05:00", duration: "6h 20m", classes: ["SL", "3A", "2A", "1A"], fromPrice: 285 },
  { no: "12639", name: "Brindavan Express", from: "Chennai", to: "Bengaluru", dep: "07:50", arr: "14:10", duration: "6h 20m", classes: ["CC", "2S"], fromPrice: 175 },
  { no: "22691", name: "Rajdhani Express", from: "Bengaluru", to: "New Delhi", dep: "20:00", arr: "05:55", duration: "33h 55m", classes: ["3A", "2A", "1A"], fromPrice: 2495 },
  { no: "12626", name: "Kerala Express", from: "Chennai", to: "Thiruvananthapuram", dep: "11:45", arr: "05:15", duration: "17h 30m", classes: ["SL", "3A", "2A"], fromPrice: 545 },
  { no: "20643", name: "Vande Bharat Express", from: "Chennai", to: "Mysuru", dep: "05:50", arr: "12:20", duration: "6h 30m", classes: ["CC", "EC"], fromPrice: 1365 },
  { no: "16127", name: "Guruvayur Express", from: "Chennai", to: "Guruvayur", dep: "19:35", arr: "09:40", duration: "14h 05m", classes: ["SL", "3A", "2A"], fromPrice: 445 },
];

export const BUS_ROUTES = [
  { id: "b1", operator: "PMR Volvo Sleeper", type: "AC Sleeper (2+1)", from: "Churu", to: "Delhi", dep: "22:00", arr: "05:30", duration: "7h 30m", seats: 12, rating: 4.7, price: 899 },
  { id: "b2", operator: "PMR Mercedes Coach", type: "AC Seater 2+2", from: "Churu", to: "Jaipur", dep: "07:00", arr: "12:30", duration: "5h 30m", seats: 24, rating: 4.8, price: 549 },
  { id: "b3", operator: "PMR Volvo Multi-Axle", type: "AC Seater/Sleeper", from: "Delhi", to: "Manali", dep: "19:30", arr: "09:00", duration: "13h 30m", seats: 8, rating: 4.6, price: 1499 },
  { id: "b4", operator: "PMR Deluxe", type: "Non-AC Sleeper", from: "Bikaner", to: "Jaipur", dep: "23:15", arr: "06:00", duration: "6h 45m", seats: 18, rating: 4.5, price: 449 },
  { id: "b5", operator: "PMR Vande Express", type: "AC Seater 2+2", from: "Jaipur", to: "Udaipur", dep: "06:30", arr: "13:15", duration: "6h 45m", seats: 30, rating: 4.7, price: 649 },
  { id: "b6", operator: "PMR Sleeper Premium", type: "AC Sleeper (1+1)", from: "Churu", to: "Ahmedabad", dep: "20:00", arr: "10:30", duration: "14h 30m", seats: 6, rating: 4.9, price: 1699 },
];

export const CAB_TYPES = [
  { id: "c1", name: "Swift Dzire", type: "Sedan", seats: "4 + 1", ac: true, rate: 12, base: 1499, luggage: "2 bags", image: "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=800&q=80" },
  { id: "c2", name: "Toyota Etios", type: "Sedan", seats: "4 + 1", ac: true, rate: 13, base: 1599, luggage: "2 bags", image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&q=80" },
  { id: "c3", name: "Toyota Innova", type: "SUV", seats: "6 + 1", ac: true, rate: 16, base: 2199, luggage: "4 bags", image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&q=80" },
  { id: "c4", name: "Innova Crysta", type: "Premium SUV", seats: "6 + 1", ac: true, rate: 18, base: 2499, luggage: "4 bags", image: "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=800&q=80" },
  { id: "c5", name: "Ertiga", type: "MUV", seats: "6 + 1", ac: true, rate: 15, base: 1999, luggage: "3 bags", image: "https://images.unsplash.com/photo-1502877338535-766e1452684a?w=800&q=80" },
  { id: "c6", name: "Tempo Traveller", type: "Mini Coach", seats: "12 + 1", ac: true, rate: 22, base: 3499, luggage: "Ample", image: "https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?w=800&q=80" },
];

export const FLIGHTS = [
  { id: "fl1", airline: "IndiGo", code: "6E-2145", from: "DEL", fromCity: "Delhi", to: "GOI", toCity: "Goa", dep: "06:30", arr: "09:05", duration: "2h 35m", stops: "Non-stop", price: 3899, refundable: false, logo: "6E" },
  { id: "fl2", airline: "Air India", code: "AI-501", from: "DEL", fromCity: "Delhi", to: "BOM", toCity: "Mumbai", dep: "08:20", arr: "10:35", duration: "2h 15m", stops: "Non-stop", price: 4599, refundable: true, logo: "AI" },
  { id: "fl3", airline: "Vistara", code: "UK-863", from: "BOM", fromCity: "Mumbai", to: "SXR", toCity: "Srinagar", dep: "10:15", arr: "13:00", duration: "2h 45m", stops: "Non-stop", price: 6799, refundable: true, logo: "UK" },
  { id: "fl4", airline: "IndiGo", code: "6E-6182", from: "DEL", fromCity: "Delhi", to: "COK", toCity: "Kochi", dep: "14:20", arr: "17:35", duration: "3h 15m", stops: "Non-stop", price: 5299, refundable: false, logo: "6E" },
  { id: "fl5", airline: "SpiceJet", code: "SG-8721", from: "JAI", fromCity: "Jaipur", to: "BLR", toCity: "Bengaluru", dep: "16:45", arr: "19:25", duration: "2h 40m", stops: "Non-stop", price: 4199, refundable: false, logo: "SG" },
  { id: "fl6", airline: "Air India", code: "AI-865", from: "DEL", fromCity: "Delhi", to: "MAA", toCity: "Chennai", dep: "20:10", arr: "22:55", duration: "2h 45m", stops: "Non-stop", price: 5499, refundable: true, logo: "AI" },
  { id: "fl7", airline: "Go First", code: "G8-317", from: "BOM", fromCity: "Mumbai", to: "GOI", toCity: "Goa", dep: "07:10", arr: "08:20", duration: "1h 10m", stops: "Non-stop", price: 2999, refundable: false, logo: "G8" },
  { id: "fl8", airline: "SpiceJet", code: "SG-2445", from: "DEL", fromCity: "Delhi", to: "HYD", toCity: "Hyderabad", dep: "11:30", arr: "13:55", duration: "2h 25m", stops: "Non-stop", price: 3899, refundable: false, logo: "SG" },
];

export const AIRPORTS = [
  { code: "DEL", name: "Delhi \u2014 IGI" },
  { code: "BOM", name: "Mumbai \u2014 CSMIA" },
  { code: "BLR", name: "Bengaluru \u2014 Kempegowda" },
  { code: "MAA", name: "Chennai \u2014 MAA" },
  { code: "HYD", name: "Hyderabad \u2014 RGIA" },
  { code: "GOI", name: "Goa \u2014 Dabolim" },
  { code: "COK", name: "Kochi \u2014 CIAL" },
  { code: "JAI", name: "Jaipur \u2014 JAI" },
  { code: "SXR", name: "Srinagar \u2014 SXR" },
];

export const HOTELS = [
  {
    id: "h1",
    name: "The Leela Palace Udaipur",
    city: "Udaipur",
    area: "Lake Pichola",
    stars: 5,
    rating: 4.9,
    reviews: 1284,
    price: 18999,
    original: 24999,
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=900&q=80",
    amenities: ["Pool", "Spa", "WiFi", "Restaurant", "Breakfast"],
    tag: "Luxury"
  },
  {
    id: "h2",
    name: "Taj Lake Palace",
    city: "Udaipur",
    area: "Lake Pichola",
    stars: 5,
    rating: 4.8,
    reviews: 987,
    price: 22499,
    original: 27999,
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=900&q=80",
    amenities: ["Heritage", "Spa", "WiFi", "Restaurant", "Boat Ride"],
    tag: "Heritage"
  },
  {
    id: "h3",
    name: "The Oberoi Amarvilas",
    city: "Agra",
    area: "Taj East Gate",
    stars: 5,
    rating: 4.9,
    reviews: 1567,
    price: 28499,
    original: 34999,
    image: "https://images.unsplash.com/photo-1610530460358-dc9d3e56b3d5?w=900&q=80",
    amenities: ["Taj View", "Pool", "Spa", "WiFi", "Breakfast"],
    tag: "Luxury"
  },
  {
    id: "h4",
    name: "Novotel Goa Resort & Spa",
    city: "Goa",
    area: "Candolim Beach",
    stars: 4,
    rating: 4.6,
    reviews: 2145,
    price: 6999,
    original: 9499,
    image: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=900&q=80",
    amenities: ["Beach", "Pool", "WiFi", "Restaurant", "Bar"],
    tag: "Beach"
  },
  {
    id: "h5",
    name: "The Solitaire Hotel",
    city: "Manali",
    area: "Old Manali",
    stars: 4,
    rating: 4.5,
    reviews: 876,
    price: 4499,
    original: 6299,
    image: "https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=900&q=80",
    amenities: ["Mountain View", "WiFi", "Restaurant", "Heater", "Parking"],
    tag: "Mountains"
  },
  {
    id: "h6",
    name: "Kumarakom Lake Resort",
    city: "Kerala",
    area: "Kumarakom",
    stars: 5,
    rating: 4.8,
    reviews: 1123,
    price: 12499,
    original: 15999,
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=900&q=80",
    amenities: ["Backwater", "Ayurveda", "Pool", "WiFi", "Meals"],
    tag: "Backwater"
  },
];

export const POPULAR_HOTEL_CITIES = ["Goa", "Manali", "Jaipur", "Udaipur", "Kerala", "Agra", "Mumbai", "Delhi"];

export const BLOG_POSTS = [
  {
    id: "b1",
    slug: "top-10-monsoon-destinations-india",
    title: "Top 10 Monsoon Destinations to Experience Incredible India",
    excerpt: "From the misty Munnar tea gardens to the rain-drenched valleys of Coorg \u2014 discover India's most magical places when the skies open up.",
    category: "Destinations",
    author: "Priya Sharma",
    date: "2025-06-28",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=1200&q=80",
    tags: ["Monsoon", "Nature", "Travel Tips"],
  },
  {
    id: "b2",
    slug: "packing-checklist-himalayan-trek",
    title: "The Ultimate Packing Checklist for Your First Himalayan Trek",
    excerpt: "Heading to Manali, Ladakh or Spiti? Here's exactly what to pack \u2014 from thermals to trail mix \u2014 nothing more, nothing less.",
    category: "Travel Tips",
    author: "Karthik Menon",
    date: "2025-06-15",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1618500508371-d0158e696eb0?w=1200&q=80",
    tags: ["Himalayas", "Packing", "Adventure"],
  },
  {
    id: "b3",
    slug: "kerala-backwaters-houseboat-guide",
    title: "Kerala Backwaters: A Complete Houseboat Guide for 2025",
    excerpt: "How to pick the right houseboat, best time to visit, food to expect, and hidden gems along the Alleppey and Kumarakom routes.",
    category: "Guides",
    author: "Ravi Kumar",
    date: "2025-05-22",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1200&q=80",
    tags: ["Kerala", "Houseboat", "South India"],
  },
  {
    id: "b4",
    slug: "budget-goa-trip-under-15000",
    title: "How to Plan a Goa Trip Under \u20b915,000 (Yes, Really!)",
    excerpt: "Beach shacks, scooter rentals, and where the locals eat \u2014 our step-by-step budget breakdown for the perfect Goan getaway.",
    category: "Budget Travel",
    author: "Meera Iyer",
    date: "2025-05-08",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1582972236019-ea4af5ffe587?w=1200&q=80",
    tags: ["Goa", "Budget", "Beach"],
  },
  {
    id: "b5",
    slug: "rajasthan-heritage-circuit-jaipur-udaipur",
    title: "The Royal Rajasthan Circuit \u2014 Jaipur to Udaipur in 7 Days",
    excerpt: "Palaces, camel safaris, mirror work and the world's most beautiful lakes. Your day-by-day itinerary through the land of kings.",
    category: "Itineraries",
    author: "Anand Rathore",
    date: "2025-04-25",
    readTime: "12 min read",
    image: "https://images.unsplash.com/photo-1616693139578-f1c17deb0d4f?w=1200&q=80",
    tags: ["Rajasthan", "Heritage", "Itinerary"],
  },
  {
    id: "b6",
    slug: "solo-female-travel-safety-india",
    title: "Solo Female Travel in India: 15 Safety Tips We Swear By",
    excerpt: "Real advice from women who've backpacked from Kashmir to Kanyakumari \u2014 confidence, comfort and connection on the road.",
    category: "Travel Tips",
    author: "Sneha Reddy",
    date: "2025-04-10",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=80",
    tags: ["Solo Travel", "Safety", "Women"],
  },
];

export const FAQS = [
  {
    category: "Bookings & Payments",
    items: [
      { q: "How do I book a trip with PMR Travels?", a: "You can book directly through this website, call our team at +91 9397363140, or visit our office in Taranagar, Churu. Online bookings receive an instant confirmation via SMS & email." },
      { q: "What payment methods do you accept?", a: "We accept UPI (Google Pay, PhonePe, Paytm, BHIM), credit and debit cards (Visa, Mastercard, RuPay, Amex), net banking from all major banks, and Paytm wallet. Bank transfer and cash are supported at the office." },
      { q: "Do I need to pay the full amount upfront?", a: "For tour packages, only a 25% advance is required to confirm your booking. The remaining balance is payable 15 days before travel. Bus, cab, hotel and flight bookings are paid in full at the time of booking." },
      { q: "Is my payment secure?", a: "Absolutely. All payments are processed through PCI-DSS certified gateways with 256-bit encryption. We never store your card details on our servers." },
    ],
  },
  {
    category: "Cancellations & Refunds",
    items: [
      { q: "How can I cancel my booking?", a: "Visit the Cancel Ticket page (in the footer), enter your Booking ID and registered phone number, choose a reason, and confirm. You can also call +91 9397363140 for assisted cancellation." },
      { q: "What is your refund policy?", a: "Refunds are calculated based on how many days before travel you cancel: 100% (15+ days), 75% (7-14 days), 50% (3-6 days), 25% (1-2 days), 0% (within 24 hours or no-show). See our full Refund Policy page for details." },
      { q: "How long does a refund take?", a: "UPI and wallet refunds are usually instant to 24 hours. Card and net-banking refunds take 5-7 business days to reflect. Cash / cheque bookings are refunded via NEFT within 7-10 days." },
    ],
  },
  {
    category: "Travel & Safety",
    items: [
      { q: "Are your vehicles insured and driver-verified?", a: "Yes. Every vehicle in our fleet carries commercial insurance & fitness certificates. All drivers are police-verified, drug-tested and undergo annual defensive driving training." },
      { q: "What if my bus / flight / train is delayed or cancelled?", a: "For services operated by us (buses), we offer free rebooking or full refund. For third-party services (airlines, IRCTC, hotels), we help you claim per their published rules and provide 24/7 customer support." },
      { q: "Do you provide travel insurance?", a: "Yes, complimentary basic travel insurance is included on every tour package. Comprehensive add-on insurance is available at nominal cost during checkout." },
    ],
  },
  {
    category: "Custom Trips & Groups",
    items: [
      { q: "Can I customise a tour package?", a: "Absolutely \u2014 90% of our bookings are custom. Share your dates, budget, group size and interests via the Contact form, and our travel expert will design a custom itinerary within 24 hours." },
      { q: "Do you handle corporate & wedding bookings?", a: "Yes, we specialise in group travel for corporates, weddings, pilgrimages and college trips. Volume discounts, dedicated coordinators and 24x7 on-trip support included." },
      { q: "What's the maximum group size you can accommodate?", a: "We've successfully handled groups of 500+ for weddings and corporate events. From 4-seater cabs to 45-seater Volvo coaches to a fleet of buses \u2014 we can scale to your needs." },
    ],
  },
];

export const ADMIN_MOCK = {
  credentials: { username: "admin", password: "pmr@2025", otp: "142536" },
  agents: [
    { phone: "9397363140", otp: "142536", name: "B.L. Baror", agentId: "PMRAG001", role: "Super Agent" },
    { phone: "9876543210", otp: "142536", name: "Ramesh Kumar", agentId: "PMRAG002", role: "Regional Agent" },
  ],
  agentDashboard: {
    walletBalance: 45280,
    totalCommission: 128650,
    thisMonthCommission: 18420,
    bookingsMade: 87,
    clientsServed: 42,
    conversionRate: "68%",
    recentBookings: [
      { id: "PMR12345678", client: "Karthik S.", type: "Package", amount: 14999, commission: 1499, status: "Confirmed", date: "2025-06-30" },
      { id: "PMRB87654321", client: "Meera Nair", type: "Bus", amount: 899, commission: 90, status: "Confirmed", date: "2025-06-30" },
      { id: "PMRF9K3L2", client: "Anand R.", type: "Flight", amount: 3899, commission: 195, status: "Confirmed", date: "2025-06-29" },
      { id: "PMRH11223344", client: "Priya M.", type: "Hotel", amount: 44838, commission: 4483, status: "Confirmed", date: "2025-06-29" },
      { id: "PMRC55667788", client: "Ravi K.", type: "Cab", amount: 2199, commission: 220, status: "Pending", date: "2025-06-29" },
    ],
  },
  stats: [
    { label: "Total Bookings", value: "1,284", change: "+12.4%", trend: "up", icon: "Ticket" },
    { label: "Revenue (This Month)", value: "\u20b9 18.4L", change: "+8.7%", trend: "up", icon: "IndianRupee" },
    { label: "New Enquiries", value: "96", change: "+18", trend: "up", icon: "MessageSquare" },
    { label: "Cancellations", value: "14", change: "-3", trend: "down", icon: "XCircle" },
  ],
  recentBookings: [
    { id: "PMR12345678", customer: "Karthik S.", type: "Package", item: "Manali - Solang - Rohtang", amount: 14999, status: "Confirmed", date: "2025-06-30" },
    { id: "PMRB87654321", customer: "Meera Nair", type: "Bus", item: "Churu \u2192 Delhi (Volvo)", amount: 899, status: "Confirmed", date: "2025-06-30" },
    { id: "PMRF9K3L2", customer: "Anand R.", type: "Flight", item: "DEL \u2192 GOI (IndiGo)", amount: 3899, status: "Confirmed", date: "2025-06-29" },
    { id: "PMRH11223344", customer: "Priya M.", type: "Hotel", item: "Leela Palace Udaipur (2N)", amount: 44838, status: "Confirmed", date: "2025-06-29" },
    { id: "PMRC55667788", customer: "Ravi K.", type: "Cab", item: "Innova - Churu \u2192 Jaipur", amount: 2199, status: "Pending", date: "2025-06-29" },
    { id: "PMR99887766", customer: "Sneha R.", type: "Package", item: "Kerala Backwater Diaries", amount: 12499, status: "Confirmed", date: "2025-06-28" },
    { id: "PMRB44556677", customer: "Vijay T.", type: "Bus", item: "Jaipur \u2192 Udaipur (Mercedes)", amount: 649, status: "Cancelled", date: "2025-06-28" },
    { id: "PMRH22334455", customer: "Aditi K.", type: "Hotel", item: "Novotel Goa Resort (3N)", amount: 24756, status: "Confirmed", date: "2025-06-27" },
  ],
  enquiries: [
    { id: "E1042", name: "Rohan Gupta", phone: "+91 98765 43210", destination: "Kashmir", travellers: "4 Adults", status: "New", date: "2025-06-30" },
    { id: "E1041", name: "Divya P.", phone: "+91 91234 56789", destination: "Kerala", travellers: "2 Adults, 1 Child", status: "Contacted", date: "2025-06-30" },
    { id: "E1040", name: "Suresh B.", phone: "+91 99887 76655", destination: "Rajasthan", travellers: "6 Adults", status: "Quote Sent", date: "2025-06-29" },
    { id: "E1039", name: "Anjali T.", phone: "+91 98123 45678", destination: "Goa", travellers: "2 Adults", status: "Booked", date: "2025-06-29" },
    { id: "E1038", name: "Manoj V.", phone: "+91 97654 32109", destination: "Ooty", travellers: "4 Adults, 2 Kids", status: "New", date: "2025-06-28" },
  ],
  revenueByCategory: [
    { label: "Packages", value: 62, color: "bg-teal-600" },
    { label: "Hotels", value: 48, color: "bg-orange-500" },
    { label: "Flights", value: 34, color: "bg-indigo-500" },
    { label: "Bus", value: 22, color: "bg-emerald-500" },
    { label: "Cabs", value: 18, color: "bg-amber-500" },
    { label: "Trains", value: 12, color: "bg-violet-500" },
  ],
  monthlyBookings: [
    { month: "Jan", value: 82 },
    { month: "Feb", value: 74 },
    { month: "Mar", value: 96 },
    { month: "Apr", value: 118 },
    { month: "May", value: 156 },
    { month: "Jun", value: 184 },
  ],
};

export const DESTINATIONS = [
  {
    id: "manali",
    name: "Manali",
    state: "Himachal Pradesh",
    tours: 24,
    from: 12999,
    image:
      "https://images.unsplash.com/photo-1618500508371-d0158e696eb0?w=900&q=80",
    tag: "Snow Escape",
  },
  {
    id: "goa",
    name: "Goa",
    state: "West Coast",
    tours: 32,
    from: 8499,
    image:
      "https://images.unsplash.com/photo-1582972236019-ea4af5ffe587?w=900&q=80",
    tag: "Beach Party",
  },
  {
    id: "kerala",
    name: "Kerala",
    state: "God's Own Country",
    tours: 28,
    from: 9999,
    image:
      "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=900&q=80",
    tag: "Backwaters",
  },
  {
    id: "kashmir",
    name: "Kashmir",
    state: "Paradise on Earth",
    tours: 18,
    from: 15499,
    image:
      "https://images.unsplash.com/photo-1595815771614-ade9d652a65d?w=900&q=80",
    tag: "Trending",
  },
  {
    id: "ooty",
    name: "Ooty",
    state: "Tamil Nadu",
    tours: 21,
    from: 6499,
    image:
      "https://images.unsplash.com/photo-1638886540342-240980f60d25?w=900&q=80",
    tag: "Hill Station",
  },
  {
    id: "rajasthan",
    name: "Rajasthan",
    state: "Land of Kings",
    tours: 26,
    from: 11999,
    image:
      "https://images.unsplash.com/photo-1616693139578-f1c17deb0d4f?w=900&q=80",
    tag: "Heritage",
  },
];

export const PACKAGES = [
  {
    id: "pkg1",
    title: "Manali - Solang - Rohtang",
    destination: "Manali",
    nights: 5,
    days: 6,
    price: 14999,
    original: 18999,
    rating: 4.8,
    reviews: 342,
    inclusions: ["Flights", "Hotel", "Cab", "Breakfast"],
    image:
      "https://images.unsplash.com/photo-1618500508371-d0158e696eb0?w=900&q=80",
  },
  {
    id: "pkg2",
    title: "Goa Beach Bliss",
    destination: "Goa",
    nights: 3,
    days: 4,
    price: 8499,
    original: 11999,
    rating: 4.7,
    reviews: 512,
    inclusions: ["Hotel", "Sightseeing", "Meals"],
    image:
      "https://images.unsplash.com/photo-1582972236019-ea4af5ffe587?w=900&q=80",
  },
  {
    id: "pkg3",
    title: "Kerala Backwater Diaries",
    destination: "Kerala",
    nights: 4,
    days: 5,
    price: 12499,
    original: 15999,
    rating: 4.9,
    reviews: 289,
    inclusions: ["Houseboat", "Ayurveda", "Meals"],
    image:
      "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=900&q=80",
  },
  {
    id: "pkg4",
    title: "Kashmir Paradise Tour",
    destination: "Kashmir",
    nights: 6,
    days: 7,
    price: 19999,
    original: 24999,
    rating: 4.9,
    reviews: 421,
    inclusions: ["Flights", "Shikara", "Gulmarg"],
    image:
      "https://images.unsplash.com/photo-1595815771614-ade9d652a65d?w=900&q=80",
  },
  {
    id: "pkg5",
    title: "Ooty & Coonoor Retreat",
    destination: "Ooty",
    nights: 2,
    days: 3,
    price: 6499,
    original: 8499,
    rating: 4.6,
    reviews: 198,
    inclusions: ["Cab", "Hotel", "Toy Train"],
    image:
      "https://images.unsplash.com/photo-1638886540342-240980f60d25?w=900&q=80",
  },
  {
    id: "pkg6",
    title: "Royal Rajasthan Circuit",
    destination: "Rajasthan",
    nights: 7,
    days: 8,
    price: 22999,
    original: 28999,
    rating: 4.8,
    reviews: 267,
    inclusions: ["Palace Stay", "Camel Safari", "Meals"],
    image:
      "https://images.unsplash.com/photo-1616693139578-f1c17deb0d4f?w=900&q=80",
  },
];

export const FLEET = [
  { id: "f1", name: "Volvo Multi-Axle A/C Sleeper", seats: "36 + 2", type: "Luxury Bus", price: "₹ 45/km", features: ["WiFi", "USB Charging", "Blankets"] },
  { id: "f2", name: "Mercedes-Benz Coach", seats: "45 + 1", type: "Premium Bus", price: "₹ 55/km", features: ["Reclining", "LED TV", "Restroom"] },
  { id: "f3", name: "Tempo Traveller A/C", seats: "17 + 1", type: "Mini Coach", price: "₹ 22/km", features: ["Push-back", "Music", "Ample Space"] },
  { id: "f4", name: "Toyota Innova Crysta", seats: "6 + 1", type: "Premium SUV", price: "₹ 16/km", features: ["A/C", "Comfortable", "Family Friendly"] },
  { id: "f5", name: "Swift Dzire Sedan", seats: "4 + 1", type: "Economy Sedan", price: "₹ 12/km", features: ["A/C", "Sanitised", "Verified Driver"] },
  { id: "f6", name: "Force Urbania", seats: "12 + 1", type: "Luxury Van", price: "₹ 26/km", features: ["Captain Seats", "WiFi", "Charging"] },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Karthik Subramanian",
    place: "Chennai",
    text:
      "Booked our Kashmir family trip through PMR — from the driver's punctuality to hotel comfort, everything was perfect. The itinerary had zero surprises. Highly recommended!",
    rating: 5,
    avatar: "https://i.pravatar.cc/120?img=52",
  },
  {
    id: 2,
    name: "Meera Nair",
    place: "Coimbatore",
    text:
      "We hired a Tempo Traveller for our college reunion to Ooty. Clean vehicle, courteous driver, transparent pricing. PMR Travels made it memorable.",
    rating: 5,
    avatar: "https://i.pravatar.cc/120?img=45",
  },
  {
    id: 3,
    name: "Anand & Priya",
    place: "Madurai",
    text:
      "Our honeymoon in Kerala was magical. The houseboat, the Ayurvedic spa, the hill drives — every detail was thought through. Thank you PMR team!",
    rating: 5,
    avatar: "https://i.pravatar.cc/120?img=32",
  },
  {
    id: 4,
    name: "Ravi Krishnan",
    place: "Churu, Rajasthan",
    text:
      "Been booking with PMR for the last 8 years for our family pilgrimages. Reliable, affordable and always available. They feel like family now.",
    rating: 5,
    avatar: "https://i.pravatar.cc/120?img=68",
  },
];

export const STATS = [
  { value: "2025", label: "Established" },
  { value: "15,000+", label: "Happy Travellers" },
  { value: "250+", label: "Tour Destinations" },
  { value: "98%", label: "Repeat Customers" },
];

export const WHY_US = [
  {
    icon: "BadgeCheck",
    title: "IATA Certified Agency",
    desc: "Government registered and IATA accredited — your money and journey are 100% secure.",
  },
  {
    icon: "HeartHandshake",
    title: "24 / 7 Human Support",
    desc: "Real people, real help — anytime you need us before, during and after your trip.",
  },
  {
    icon: "Wallet",
    title: "Best Price Guarantee",
    desc: "Find a lower price elsewhere? We'll match it and add extra perks on top.",
  },
  {
    icon: "ShieldCheck",
    title: "Fully Insured Travel",
    desc: "Every booking includes complimentary travel insurance for total peace of mind.",
  },
];
